import { render, staticRenderFns } from "./ShoppingLists.vue?vue&type=template&id=0c0ce641&"
import script from "./ShoppingLists.vue?vue&type=script&lang=js&"
export * from "./ShoppingLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports